export default __webpack_public_path__ + "static/media/how_to_4.75e12049.png";